<!--
 * @Author: your name
 * @Date: 2021-01-21 20:08:44
 * @LastEditTime: 2022-01-12 10:22:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \rightcloud-console\src\views\cclogin.vue
-->
<template>
    <div class="cclogin-container">
        <form id="loginForm"
              class="login-form"
              :action="params.ccPortalUrl"
              method="post"
              v-show="false">
            <input type="text"
                   :value="params.username"
                   class="hide-input"
                   name="username" />
            <input type="password"
                   :value="params.password"
                   class="hide-input"
                   name="password" />
            <input type="submit"
                   value="Submit"
                   onclick="login">
        </form>
        <!-- 替换ivew本身得loading -->
        <Spin v-if="tableLoading"
              fix>
            <Icon type="ios-loading"
                  :size='24'
                  class="demo-spin-icon-load"></Icon>
            <div>{{$t('加载中')}}</div>
        </Spin>
    </div>
</template>

<script>
import API from '@/service/api.js'
export default {
    name: 'hpcv1console',
    data () {
        return {
            tableLoading: true,
            params: {
                ccPortalUrl: null,
                username: null,
                password: null
            }
        }
    },
    created () {
        this.getUser()
    },
    methods: {
        // 获取ccPortal用户名，密码
        getUser () {
            this.params = {
                ccPortalUrl: null,
                username: null,
                password: null
            }
            this.axios.get(this.urlFormat(API.GET_CCPORTAL_INFO, false)).then(res => {
                this.params = {
                    ccPortalUrl: res.ccPortalUrl,
                    username: res.userId,
                    password: this.$decrypt(res.userPwd)
                }
                this.$nextTick(() => {
                    if (this.params !== null && this.params.username && this.params.password) {
                        this.login()
                    }
                })
            })
        },
        login () {
            document.getElementById('loginForm').submit()
        }
    }
}
</script>
<style lang="less">
.cclogin-container {
    .ivu-spin-dot {
        display: none !important;
    }
    .ivu-spin-text {
        display: block !important;
    }
    .demo-spin-icon-load {
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
}
</style>
